import type { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP interceptor that removes the "admin." prefix from URLs in API requests.
 *
 * @example
 * Transforms: https://admin.dtis-d.dev.dp.schaeffler/api/...
 * To: https://dtis-d.dev.dp.schaeffler/api/...
 */
export const urlRewriteInterceptor: HttpInterceptorFn = (req, next) => {
  // Check if URL includes the admin prefix that needs to be removed
  const adminPrefixRegex = /^(https?:\/\/)admin\.(dtis-[a-z]\.dev\.dp\.schaeffler)/i;

  if (adminPrefixRegex.test(req.url)) {
    // Create new URL by removing "admin." prefix
    const modifiedUrl = req.url.replace(adminPrefixRegex, '$1$2');

    // Clone the request with the modified URL
    const modifiedReq = req.clone({
      url: modifiedUrl,
    });

    return next(modifiedReq);
  }

  // If URL doesn't match pattern, proceed with original request
  return next(req);
};
